import * as Yup from "yup";

import {
  OfficeButton,
  PDFRenderer,
  RegularInsurerPicker,
  RegularSelectInput,
} from "components";
import { useEffect, useState } from "react";

import _ from "lodash";
import config from "config";
import { useCurrentUser } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { useTreatyYears } from "hooks/data/use-treaties";
import { wrapClick } from "utils";

const NICProposalTab = () => {
  const currentUser = useCurrentUser();
  const form = useFormik<any>({
    initialValues: {
      insurer: "",
      period: "",
    },
    onSubmit: () => {
      form.setFormikState((state) => ({ ...state, status: "SUBMIITED" }));
      form.setSubmitting(false);
      generateReport(form.values);
      return;
    },
    validationSchema: Yup.object().shape({
      insurer: Yup.string().required("Insurer is required"),
      period: Yup.string().required("Treaty Period is required"),
    }),
    initialStatus: "NOT_SUBMIITED",
  });
  const [url, setUrl] = useState("");
  const { years, refetch } = useTreatyYears({ insurerId: form.values.insurer });

  useEffect(() => {
    form.setFormikState((state) => ({ ...state, status: "NOT_SUBMIITED" }));
    form.setSubmitting(false);
  }, [form.values.currency, form.values.date, form.values.cheque]);

  const generateReport = (data: any) => {
    const url = `${config.asset.uri}generate_nic_proposal/${btoa(JSON.stringify({ treaty_year: data.period, emp_id: currentUser?.employee?.employee_id, insurer_id: data.insurer }))}`;
    setUrl(url);
  };

  useEffect(() => {
    if (form.values.insurer) {
      refetch({ insurerId: form.values.insurer });
    }
  }, [form.values.insurer]);

  return (
    <div className="w-full">
      <div className="py-3 flex justify-between">
        <h1 className="font-bold text-primary text-lg">
          Generate NIC Proposal
        </h1>
        <div>
          <OfficeButton
            disabled={form.isSubmitting}
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Generating ..." : "Generate Report"}
          </OfficeButton>
        </div>
      </div>
      <form className="bg-white py-6 px-6 h-auto">
        <div className="grid gap-3  grid-cols-2 shadow-sm">
          <div>
            <RegularInsurerPicker
              id="insurer"
              label="Insurer"
              rawId
              placeholder="Insurer"
              required={true}
              {...form}
            />
          </div>
          <div>
            <RegularSelectInput
              id="period"
              label="Treaty Period"
              options={
                years.map((year: any) => ({
                  label: String(year),
                  value: year,
                })) || []
              }
              placeholder="Year"
              required={true}
              {...form}
            />
          </div>
        </div>
      </form>
      <div className="pt-11">
        {form.status === "SUBMIITED" && form.isValid && (
          <PDFRenderer url={url} />
        )}
      </div>
    </div>
  );
};

export default NICProposalTab;
